import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale/pt-BR';
import { connect } from 'getstream';
import { useEffect, useState } from 'react';
import { sentryCapture } from '../../../helpers/utils';
import { useApi } from '../../../hooks/useApi';
import { SentryError } from '../../../types/enums';
import ModalDialog from '../../Modal/Dialog';

const APP_ENV = process.env.REACT_APP_ENV;
const apiKey =
	APP_ENV === 'DEV' || APP_ENV === 'STG' ? 't9zqjxm32wac' : 'efe24uu7hbbc';
const userId = APP_ENV === 'DEV' || APP_ENV === 'STG' ? '1323712' : '1322086';

export const Games = ({ eventsTournament }: any) => {
	const api = useApi();
	const [openModalIndex, setOpenModalIndex] = useState<number | null>(null);
	const [liveScores, setLiveScores] = useState(eventsTournament);

	useEffect(() => {
		const connectToFeeds = async () => {
			try {
				const response = await api.getTokenFeed();
				if (!response?.success) {
					throw new Error(response.message);
				}
				const { token } = response;

				const handleFeedUpdate = (data: any) => {
					try {
						const update: {
							macthId: string;
							update: boolean;
							gameStarted: boolean;
							result: string;
							lastUpdate: any;
						} = data.new[0].data;
						const findMatch = liveScores.some(
							(i: any) => i.event.id === update.macthId
						);

						if (findMatch && update.update) {
							setLiveScores((prevLiveScores: any) =>
								prevLiveScores.map((evento: any) =>
									evento.event.id === update.macthId
										? {
												...evento,
												gameStarted: update.gameStarted,
												teamHome: {
													...evento.teamHome,
													score: update.result.split(
														'x'
													)[0],
												},
												teamAway: {
													...evento.teamAway,
													score: update.result.split(
														'x'
													)[1],
												},
												event: {
													...evento.event,
													result: update.result,
												},
										  }
										: evento
								)
							);
						}
					} catch (e) {
						console.error('Erro no parse do feed update:', e);
					}
				};
				const clientFeed = connect(apiKey, null, userId);
				const feedUpdate = clientFeed.feed('matches', 'system', token);

				feedUpdate.subscribe(handleFeedUpdate);
			} catch (err: any) {
				sentryCapture(err, 'matchesUpdate', SentryError.Error);
			}
		};
		connectToFeeds();
	}, [eventsTournament]);

	return (
		<div className="grid gap-4 lg:grid-cols-3">
			{liveScores.map((event: any, index: number) => {
				return (
					<div
						onClick={() => {
							if (event.event?.result === '') {
								return;
							}
							if (event.scores.length === 0) {
								return;
							}
							setOpenModalIndex(
								openModalIndex === event.id ? null : event.id
							);
						}}
						className="flex flex-col"
						key={index}
					>
						<div className="flex-row h-[33px] rounded-t-lg px-4 pt-1 bg-gray-100 justify-between items-center inline-flex">
							<div className="text-primary text-xs font-bold font-bahnschrift leading-snug">
								{event.event.category.name}
							</div>
							<div className="text-primary text-xs font-bold font-bahnschrift leading-snug">
								{format(
									event.event.startAt.replace('Z', ''),
									"dd/MM • EEE • HH'h'mm",
									{ locale: ptBR }
								)}
							</div>
						</div>
						<div className="px-4 -mt-0.5 py-2 bg-gray-100 rounded-b-lg flex-col gap-px inline-flex ">
							<div className="grid grid-flow-col justify-between">
								<div className="flex flex-row justify-start w-28">
									<div className="flex flex-row items-center gap-2">
										<img
											className="w-10 h-10 object-scale-down"
											src={event.teamHome.image}
											alt={event.teamHome.name}
										/>
										<span className="text-custom-black text-left text-xs font-bold font-bahnschrift leading-snug">
											{event.teamHome.name}
										</span>
									</div>
								</div>

								<div className="flex flex-row justify-center items-center gap-1 w-16">
									<div className="text-[#818181] text-2xl font-bold font-bahnschrift leading-snug animate-slide-down">
										{event.gameStarted &&
											event.teamHome.score}
									</div>
									<div className="text-[#818181] text-xs font-bold font-bahnschrift leading-snug">
										x
									</div>
									<div className="text-[#818181] text-2xl font-bold font-bahnschrift leading-snug animate-slide-down">
										{event.gameStarted &&
											event.teamAway.score}
									</div>
								</div>

								<div className="flex flex-row justify-end w-28">
									<div className="flex flex-row items-center gap-2">
										<span className="text-custom-black text-right text-xs font-bold font-bahnschrift leading-snug">
											{event.teamAway.name}
										</span>
										<img
											className="w-10 h-10 object-scale-down"
											src={event.teamAway.image}
											alt={event.teamAway.name}
										/>
									</div>
								</div>
							</div>
							{event.event.resultStatus === 2 &&
								event.event.result !== '0x0' &&
								event.scores.length > 0 && (
									<div
										onClick={() => {
											if (event.event?.result === '')
												return;
											setOpenModalIndex(
												openModalIndex === event.id
													? null
													: event.id
											);
										}}
										className="text-[#0c67a0] text-xs text-center font-normal font-bahnschrift underline cursor-pointer"
									>
										Ver{' '}
										{event.event.category.modality ===
										'Futebol'
											? 'Gols'
											: 'Pontos'}
									</div>
								)}
							<ModalDialog
								id={event.id}
								open={openModalIndex === event.id}
								onClose={() => setOpenModalIndex(null)}
							>
								<div className="w-full px-6 pb-6 bg-white rounded-lg flex-col justify-center items-end gap-6 inline-flex">
									{event.teamHome.score !== 0 && (
										<div className="self-stretch p-4 bg-custom-white1 rounded-lg flex-col justify-center items-center gap-4 flex">
											<div className="self-stretch pb-2.5 border-b border-[#c1c1c1] justify-start items-center gap-2.5 inline-flex">
												<div className="rounded-[61px] justify-center items-center gap-2.5 flex">
													<div className="justify-start items-center gap-2.5 flex">
														<img
															className="w-8 h-8 object-scale-down"
															src={
																event.teamHome
																	.image
															}
															alt={
																event.teamHome
																	.name
															}
														/>
														<div className="text-black text-base font-normal font-bahnschrift leading-snug">
															{
																event.teamHome
																	.name
															}
														</div>
													</div>
												</div>
											</div>
											<div className="self-stretch flex-col justify-start items-start gap-2 flex">
												{event.scores &&
													event.scores
														.filter(
															(score: any) =>
																score.team
																	?.name ===
																event.teamHome
																	.name
														)
														.map(
															(
																score: any,
																index: number
															) => (
																<div
																	key={index}
																	className="self-stretch rounded justify-between items-center inline-flex"
																>
																	<div className="justify-start items-center gap-4 flex">
																		<div className="flex-col justify-center items-start gap-1.5 inline-flex">
																			<div className="justify-start items-center inline-flex">
																				<div className="text-black text-base font-normal font-bahnschrift leading-[14px]">
																					{
																						score.playerName
																					}
																				</div>
																			</div>
																		</div>
																	</div>
																	<div className="flex-col justify-center items-start gap-1.5 inline-flex">
																		<div className="text-black text-base font-normal font-bahnschrift leading-[14px]">
																			{`${
																				score.score
																			} ${
																				Number(
																					score.score
																				) ===
																				1
																					? score.scoutName
																					: score.scoutNameSuffix
																			}`}
																		</div>
																	</div>
																</div>
															)
														)}
											</div>
										</div>
									)}

									{event.teamAway.score !== 0 && (
										<div className="self-stretch p-4 bg-custom-white1 rounded-lg flex-col justify-center items-center gap-4 flex">
											<div className="self-stretch pb-2.5 border-b border-[#c1c1c1] justify-start items-center gap-2.5 inline-flex">
												<div className="rounded-[61px] justify-center items-center gap-2.5 flex">
													<div className="justify-start items-center gap-2.5 flex">
														<img
															className="w-8 h-8 object-scale-down"
															src={
																event.teamAway
																	.image
															}
															alt={
																event.teamAway
																	.name
															}
														/>
														<div className="text-black text-base font-normal font-bahnschrift leading-snug">
															{
																event.teamAway
																	.name
															}
														</div>
													</div>
												</div>
											</div>
											<div className="self-stretch flex-col justify-start items-start gap-2 flex">
												{event.scores &&
													event.scores
														.filter(
															(score: any) =>
																score.team
																	?.name ===
																event.teamAway
																	.name
														)
														.map(
															(
																score: any,
																index: number
															) => (
																<div
																	key={index}
																	className="self-stretch rounded justify-between items-center inline-flex"
																>
																	<div className="justify-start items-center gap-4 flex">
																		<div className="flex-col justify-center items-start gap-1.5 inline-flex">
																			<div className="justify-start items-center inline-flex">
																				<div className="text-black text-base font-normal font-bahnschrift leading-[14px]">
																					{
																						score.playerName
																					}
																				</div>
																			</div>
																		</div>
																	</div>
																	<div className="flex-col justify-center items-start gap-1.5 inline-flex">
																		<div className="text-black text-base font-normal font-bahnschrift leading-[14px]">
																			{`${
																				score.score
																			} ${
																				Number(
																					score.score
																				) ===
																				1
																					? score.scoutName
																					: score.scoutNameSuffix
																			}`}
																		</div>
																	</div>
																</div>
															)
														)}
											</div>
										</div>
									)}
								</div>
							</ModalDialog>
						</div>
					</div>
				);
			})}
		</div>
	);
};
